import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, withKeys as _withKeys, mergeProps as _mergeProps, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-11c3aa02"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  style: {"padding":"16px","height":"100%","display":"flex","flex-direction":"column","justify-content":"space-between","box-sizing":"border-box"}
}
const _hoisted_2 = {
  style: {"display":"grid","padding-top":"8px"},
  class: "gap-10"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont cm-icon-info",
  style: {"color":"var(--cm-color-text-regular)","font-weight":"normal","font-size":"18px"}
}, null, -1))
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 0,
  class: "cm-align-center gap-5",
  style: {"padding":"5px","flex-wrap":"wrap","overflow-y":"auto","max-height":"180px","display":"flex"}
}
const _hoisted_6 = { class: "cm-align-center cm-ui-mt16" }

import PolicyBindScope from '@/views/dashboard/policy/_components/policy-bind-scope.vue'
import { policyBindScopeFormRules } from '@/views/dashboard/policy/_components/policy-bind-scope-form-rule'
import CmForm from '@/components/cmForm/index.vue'
import { FormActionType, FormSize } from '@/components/cmForm/types'
import DomainCategoryPicker from './domain-category-picker.vue'
import {
  categoryIdsFullySelectedInUrlSet,
  splitLibraryAndManualUrls,
} from '../index'
import { formLabelStyle } from '@/components/cmForm/globalOpt'
import { PermissionFe } from '@/services/service-permission.service'
import {
  PolicyType,
  PolicySettingType,
} from '@/views/dashboard/_enum/policy-type'
import type { SaveSettingsReq, SettingsQueryReq } from '@/views/dashboard/policy/policy-common.service'
import {
  PolicyCommonService,
  errorDetailToFailedEntries,
  normalizeTemplateImportData,
} from '@/views/dashboard/policy/policy-common.service'
import { ExcelImportDialog } from '@/components/excel-import-dialog'
import type {
  ExcelImportDialogCopy,
  ExcelImportDialogMessages,
  ExcelImportFileResult,
} from '@/components/excel-import-dialog'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import { ElMessage } from 'element-plus'
import { computed, nextTick, PropType, ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { BrandConfig, useBrandCustomStore } from '@/services/brand-custom.service'
import { resolveHttpErrorMessage } from '@/common/error/error-code'
import { team, user } from '@/common/basis/root-injector'
import { ACCESS_RESTRICTION_LIMIT_TYPE_KEY as typeKey } from '../access-restriction-limit-type'


export default /*#__PURE__*/_defineComponent({
  __name: 'strategy-setting',
  props: {
  api: {
    type: Object as PropType<{
      saveOrUpdateApi: (data: SaveSettingsReq) => Promise<unknown>
      getApi: (q: SettingsQueryReq) => Promise<unknown>
    }>,
    required: true,
  },
  id: {
    type: String,
    default: '',
  },
  modelValue: {
    type: Boolean,
    default: false,
  },
  hasPermission: {
    type: Boolean,
    default: false,
  },
  fromGroupId: {
    type: Number as PropType<number | undefined>,
    default: undefined,
  },
},
  emits: ["update:modelValue", "refresh"],
  setup(__props, { emit: __emit }) {

const { t, locale } = useI18n()
const brandConfig = useBrandCustomStore().brandConfig as BrandConfig

const policyInjector = useReflectiveInjector([PolicyCommonService])
const policyCommonService = policyInjector.get(PolicyCommonService)

const domainExcelImportVisible = ref(false)

const domainImportDialogCopy = computed<ExcelImportDialogCopy>(() => {
  void locale.value
  const p = 'accessRestriction.domainStrategyImport'
  return {
    step1: t(`${p}.step1`),
    step2: t(`${p}.step2`),
    downloadTemplate: t(`${p}.downloadTemplate`),
    downloadTip: t(`${p}.downloadTip`),
    uploadTip: t(`${p}.uploadTip`),
    formatTip: t(`${p}.formatTip`),
    dragTip: t(`${p}.dragTip`),
    clickUpload: t(`${p}.clickUpload`),
    reupload: t(`${p}.reupload`),
    cancel: t(`${p}.cancel`),
    confirmImport: t(`${p}.confirmImport`),
    importFailTitle: t(`${p}.importFailTitle`),
    uploadFormatWarn: t(`${p}.uploadFormatWarn`),
    invalidFileFormat: t(`${p}.invalidFileFormat`),
    selectFileFirst: t(`${p}.selectFileFirst`),
  }
})

const domainImportDialogMessages = computed<ExcelImportDialogMessages>(() => {
  void locale.value
  const p = 'accessRestriction.domainStrategyImport'
  return {
    downloadSuccess: t(`${p}.templateDownloadSuccess`),
    downloadFail: t(`${p}.templateDownloadFail`),
    importSuccess: t(`${p}.importSuccess`),
  }
})

function mergeImportedDomains(urls: string[]) {
  const merged = new Set<string>()
  for (const u of categoryLibraryUrls.value) {
    const x = String(u).trim()
    if (x) merged.add(x)
  }
  for (const u of form.value.urls) {
    const x = String(u).trim()
    if (x) merged.add(x)
  }
  for (const u of manualDomainsFromStr.value) {
    if (u) merged.add(u)
  }
  for (const u of urls) {
    const x = String(u).trim()
    if (x) merged.add(x)
  }
  const { library, manual } = splitLibraryAndManualUrls([...merged])
  categoryLibraryUrls.value = library
  form.value.urls = manual
  if (manual.length > 0) {
    customTargetDomainsExpanded.value = true
  }
  nextTick(() => formRef.value?.ruleFormRef?.validateField?.('category_ids'))
}

async function onDomainImportDownload() {
  await policyCommonService.getStrategyTemplateDownload({ template_type: 'domain' })
}

async function onDomainImportFile(file: File): Promise<ExcelImportFileResult> {
  const fd = new FormData()
  fd.append('file', file)
  fd.append('template_type', 'domain')
  fd.append('team_id', String(team.getCurrentTeam().team_id))
  fd.append('uid', user.getUserInfo().uid)
  fd.append('token', user.getUserInfo().token)
  const result = (await policyCommonService.getStrategyImportParse(fd)) as {
    data?: unknown
    error_detail?: unknown
    resp_common?: { ret?: number; msg?: string }
  }
  const rc = result?.resp_common
  const ok = !rc || rc.ret === 0 || rc.msg === 'ok'
  if (rc && !ok) {
    const ret = rc.ret != null ? Number(rc.ret) : NaN
    const resolved = Number.isFinite(ret) ? resolveHttpErrorMessage(ret, rc.msg) : ''
    const err: any = new Error(
      resolved || rc.msg || t('accessRestriction.domainStrategyImport.importFail'),
    )
    err.resp_common = rc
    throw err
  }
  const list = normalizeTemplateImportData(result.data)
  const failedEntries: Record<string, string | number> = errorDetailToFailedEntries(result.error_detail)

  if (!list.length) {
    if (Object.keys(failedEntries).length) {
      return { failedEntries }
    }
    ElMessage.info(t('accessRestriction.domainStrategyImport.noDomainParsed'))
    return { failedEntries: {}, closeDialog: false, suppressSuccessToast: true }
  }
  mergeImportedDomains(list)
  return { failedEntries }
}

const props = __props

const emit = __emit

const visible = computed({
  get: () => props.modelValue,
  set: (v: boolean) => emit('update:modelValue', v),
})

const disabled = ref(!props.hasPermission)
const formRef = ref()
const customDomainsSectionRef = ref<HTMLElement | null>(null)
const customDomainInputRef = ref<{ focus?: () => void } | null>(null)
/** false 时折叠「目标域名」手写区（仍参与校验与提交，仅视觉隐藏） */
const customTargetDomainsExpanded = ref(false)
const loading = ref(false)
const loadingPage = ref(false)
/** 域名分类静态库勾选（策略保存前不与 form.urls 合并，仅提交时合并） */
const categoryLibraryUrls = ref<string[]>([])
const urlStr = ref('')
const limit_type_copy = ref<number | undefined>(undefined)

const strategyOver = ref({ type: PolicyType.internet, current: '' })

const defaultFormData = () => ({
  name: '',
  urls: [] as string[],
  limit_type: 1,
  /** 域名分类多选（策略 JSON 中 category_ids） */
  category_ids: [] as number[],
  group_ids: [] as number[],
  bind_mode: 0,
  device_ids: [] as string[],
  id: undefined as string | undefined,
  status: undefined as number | undefined,
})

const form = ref(defaultFormData())

const globalOpt = { required: true }

const reg =
  /^[a-zA-Z0-9*]([a-zA-Z0-9*-]{0,61}[a-zA-Z0-9*])?(\.[a-zA-Z0-9*]([a-zA-Z0-9*-]{0,61}[a-zA-Z0-9*])?)*$/

function parseManualUrlStr(str: string): string[] {
  return str
    .split(/[,，、;；\n]/)
    .map((s) => s.trim())
    .filter(Boolean)
}

const manualDomainsFromStr = computed(() => parseManualUrlStr(urlStr.value))

/** 手写目标域名：已进表单的 + 输入框内未提交的，供分类区合计与全选判断 */
const manualDomainsMergedForPicker = computed(() => {
  const s = new Set<string>()
  for (const u of form.value.urls) {
    const x = String(u).trim()
    if (x) s.add(x)
  }
  for (const u of manualDomainsFromStr.value) {
    if (u) s.add(u)
  }
  return [...s]
})

function getMergedTargetDomains(): string[] {
  const s = new Set<string>()
  for (const u of categoryLibraryUrls.value) {
    const x = String(u).trim()
    if (x) s.add(x)
  }
  for (const u of form.value.urls) {
    const x = String(u).trim()
    if (x) s.add(x)
  }
  for (const u of manualDomainsFromStr.value) {
    if (u) s.add(u)
  }
  return [...s]
}

/** 合并静态库 + 手写后的目标域名：必填；格式仅校验手写区，分类库（category_ids 对应）域名不校验 */
const validateMergedTargetDomains = (_rule: unknown, _value: unknown, callback: (e?: Error) => void) => {
  const merged = getMergedTargetDomains()
  if (merged.length === 0) {
    callback(new Error(t('accessRestriction.targetDomainRequired')))
    return
  }
  for (const item of manualDomainsMergedForPicker.value) {
    if (!reg.test(item)) {
      callback(new Error(t('accessRestriction.domainRuleError')))
      return
    }
  }
  callback()
}

const formColumns = computed(() => {
  void locale.value
  void customTargetDomainsExpanded.value
  return [
  {
    label: t('accessRestriction.policyName'),
    prop: 'name',
    colOpt: { span: 6 },
    inputOpt: { maxlength: 50 },
  },
  {
    label: t('accessRestriction.policyAttr'),
    slot: true,
    prop: 'limit_type',
    type: 'radio',
    dictData: [
      { label: t('accessRestriction.blacklistDesc'), value: 1 },
      { label: t('accessRestriction.whitelistDesc'), value: 2 },
      { label: t('accessRestriction.recordOnlyDesc'), value: 3 },
    ],
    colOpt: { span: 24 },
  },
  {
    label: t('accessRestriction.targetDomain'),
    prop: 'category_ids',
    required: false,
    slot: true,
    labelSlot: true,
    formItemOpt: { required: false },
    rules: [{ custom: { validator: validateMergedTargetDomains, trigger: ['change', 'blur'] } }],
    colOpt: { span: 24 },
  },
  {
    hiddenAllLabel: true,
    required: false,
    footerSlot: true,
    slot: true,
    placeholder: t('accessRestriction.targetDomainManualPlaceholder'),
    prop: 'urls',
    inputType: 'textarea',
    hidden: () => !customTargetDomainsExpanded.value,
    inputOpt: { rows: 4, autosize: { minRows: 4, maxRows: 8 } },
    colOpt: {
      span: 24,
      style: 'margin: -15px 0 15px',
    },
  },
  {
    label: t('policyBindScope.applyMode'),
    prop: 'group_ids',
    required: false,
    formItemOpt: { required: false },
    rules: policyBindScopeFormRules(() => form.value, t),
    labelSlot: true,
    slot: true,
    colOpt: { span: 24,  },
  },
]
})

function validateTree() {
  formRef.value?.ruleFormRef?.validateField?.('group_ids')
}

function toggleCustomDomainsSection() {
  customTargetDomainsExpanded.value = !customTargetDomainsExpanded.value
  if (!customTargetDomainsExpanded.value) return
  nextTick(() => {
    customDomainsSectionRef.value?.scrollIntoView({ behavior: 'smooth', block: 'center' })
    customDomainInputRef.value?.focus?.()
  })
}

function handleCloseUrl(index: number) {
  form.value.urls.splice(index, 1)
  nextTick(() => formRef.value?.ruleFormRef?.validateField?.('category_ids'))
}

function handleUrls() {
  if (!urlStr.value.trim()) return
  form.value.urls.push(
    ...urlStr.value
      .split(/[,，、;；]/)
      .filter((item) => !!item.trim())
      .map((item) => item.trimEnd().trimStart()),
  )
  form.value.urls = [...new Set(form.value.urls)]
  urlStr.value = ''
  nextTick(() => formRef.value?.ruleFormRef?.validateField?.('category_ids'))
}

function handleResetToDefault() {
  categoryLibraryUrls.value = []
  form.value = defaultFormData()
  urlStr.value = ''
  limit_type_copy.value = undefined
  strategyOver.value = { type: PolicyType.internet, current: '' }
  customTargetDomainsExpanded.value = false
}

function onFormReset() {
  visible.value = false
  handleResetToDefault()
}

function cancel() {
  formRef.value?.handleReset?.()
  visible.value = false
  urlStr.value = ''
  handleResetToDefault()
}

async function handleSubmit() {
  const valid = await formRef.value?.handleSubmit?.()
  if (!valid) return
  const bm = form.value.bind_mode ?? 0
  loadingPage.value = true
  loading.value = disabled.value = true
  try {
    const lt = form.value.limit_type ?? 1
    const merged = getMergedTargetDomains()
    const strategy: Record<string, unknown> = {
      limit_type: lt,
      status: form.value.status,
      [typeKey[lt] || 'black_list']: merged.join(','),
    }
    strategy.category_ids = categoryIdsFullySelectedInUrlSet(new Set(merged))
    const formData: SaveSettingsReq = {
      name: form.value.name,
      group_ids: form.value.group_ids,
      device_ids: form.value.device_ids || [],
      bind_mode: bm,
      id: form.value.id ?? '',
      type: PolicySettingType.internet,
      strategy_type: PolicyType.internet,
      strategy: JSON.stringify(strategy),
    }
    const result: any = await props.api.saveOrUpdateApi(formData).catch(() => undefined)
    const ok = result?.resp_common?.msg === 'ok'
    ElMessage({
      type: ok ? 'success' : 'error',
      message: ok ? t('accessRestriction.operateSuccess') : t('accessRestriction.operateFailed'),
    })
    if (ok) {
      formRef.value?.handleReset?.()
      emit('refresh')
      visible.value = false
      handleResetToDefault()
    }
  } finally {
    loading.value = disabled.value = loadingPage.value = false
  }
}

watch(
  () => getMergedTargetDomains().join('\u0000'),
  () => {
    nextTick(() => formRef.value?.ruleFormRef?.validateField?.('category_ids'))
  },
)

function normalizeCategoryIdsFromStrategy(strategy: Record<string, unknown>): number[] {
  const raw = strategy.category_ids
  if (Array.isArray(raw)) {
    return raw.map((x) => Number(x)).filter((n) => Number.isFinite(n))
  }
  const single = strategy.category_id
  if (single != null && single !== '') {
    const n = Number(single)
    return Number.isFinite(n) ? [n] : []
  }
  return []
}

watch(
  () => props.modelValue,
  async (nv) => {
    handleResetToDefault()
    if (!nv) return
    if (!props.id) return
    loadingPage.value = true
    strategyOver.value.current = props.id
    try {
      const result: any = await props.api.getApi({
        id: props.id,
        type: PolicySettingType.internet,
      })
      const st = result.strategy as Record<string, unknown>
      limit_type_copy.value = result.strategy.limit_type === 0 ? undefined : result.strategy.limit_type
      const rawUrls =
        result.strategy[typeKey[result.strategy.limit_type]]?.split?.(',')?.map((s: string) => s.trim()).filter(Boolean) ||
        []
      const { library, manual } = splitLibraryAndManualUrls(rawUrls)
      categoryLibraryUrls.value = library
      form.value = {
        id: props.id,
        name: result.name,
        group_ids: result.strategy_group_ids,
        bind_mode: result.bind_mode ?? 0,
        device_ids: result.device_ids ?? [],
        ...result.strategy,
        urls: manual,
        category_ids: normalizeCategoryIdsFromStrategy(st),
        limit_type: result.strategy.limit_type === 0 ? undefined : result.strategy.limit_type,
      }
      customTargetDomainsExpanded.value = manual.length > 0
      urlStr.value = ''
      delete (form.value as { category_id?: unknown }).category_id
      await nextTick()
      setTimeout(() => {
        formRef.value?.ruleFormRef?.clearValidate?.('limit_type')
        formRef.value?.ruleFormRef?.clearValidate?.('group_ids')
      }, 0)
    } finally {
      loadingPage.value = false
    }
  },
  { immediate: true },
)

return (_ctx: any,_cache: any) => {
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _directive_loading = _resolveDirective("loading")!

  return (visible.value)
    ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(CmForm, {
          formSize: _unref(FormSize).Small,
          ref_key: "formRef",
          ref: formRef,
          style: {"flex":"1","overflow-y":"auto","overflow-x":"hidden"},
          modelValue: form.value,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form).value = $event)),
          formType: _unref(FormActionType).Other,
          "onUpdate:formType": _cache[7] || (_cache[7] = ($event: any) => ((_unref(FormActionType).Other) = $event)),
          disabled: disabled.value,
          "onUpdate:disabled": _cache[8] || (_cache[8] = ($event: any) => ((disabled).value = $event)),
          formColumns: formColumns.value,
          formOpt: { 'label-width': 'auto', labelPosition: 'left' },
          opeRowOpt: { justify: 'start', style: { marginTop: '20px' } },
          onReset: onFormReset,
          rowOpt: { style: { display: 'grid' }, class: 'gap-20' },
          globalOpt: globalOpt
        }, {
          limit_type: _withCtx(({ prop, formItem }) => [
            _createVNode(_component_el_radio_group, {
              modelValue: form.value[prop],
              "onUpdate:modelValue": ($event: any) => ((form.value[prop]) = $event)
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formItem.dictData, (item) => {
                    return (_openBlock(), _createBlock(_component_el_radio, {
                      disabled: form.value.limit_type !== item.value && form.value.id && limit_type_copy.value,
                      label: item.value,
                      key: item.value
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.label), 1)
                      ]),
                      _: 2
                    }, 1032, ["disabled", "label"]))
                  }), 128))
                ])
              ]),
              _: 2
            }, 1032, ["modelValue", "onUpdate:modelValue"])
          ]),
          "category_ids-label": _withCtx(({ label }) => [
            _createElementVNode("div", {
              class: "cm-align-center",
              style: _normalizeStyle([{"flex":"1"}, _unref(formLabelStyle)])
            }, [
              _createElementVNode("div", null, _toDisplayString(_ctx.$t('accessRestriction.targetDomain')), 1),
              _createVNode(_component_el_popover, {
                placement: "bottom-start",
                trigger: "hover",
                width: 400,
                offset: 0
              }, {
                reference: _withCtx(() => [
                  _hoisted_3
                ]),
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _createElementVNode("strong", null, _toDisplayString(_ctx.$t('accessRestriction.domainFillTipTitle')), 1),
                    _createElementVNode("p", null, _toDisplayString(_ctx.$t('accessRestriction.domainFillTip1')), 1),
                    _createElementVNode("p", null, _toDisplayString(_ctx.$t('accessRestriction.domainFillTip2')), 1),
                    _createElementVNode("p", null, _toDisplayString(_ctx.$t('accessRestriction.domainFillTip3')), 1),
                    (!_unref(brandConfig).is_brand_custom)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.$t('accessRestriction.domainFillTip4')), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              })
            ], 4)
          ]),
          group_ids: _withCtx(() => [
            _createVNode(PolicyBindScope, {
              "bind-mode": form.value.bind_mode ?? 0,
              "group-ids": form.value.group_ids || [],
              "device-ids": form.value.device_ids || [],
              "preset-group-id": form.value.id ? undefined : __props.fromGroupId,
              "permission-key": _unref(PermissionFe).internet_url_limit,
              "strategy-over": strategyOver.value,
              disabled: disabled.value,
              "onUpdate:bindMode": _cache[0] || (_cache[0] = 
            (v) => {
              form.value.bind_mode = v
              nextTick(() => validateTree())
            }
          ),
              "onUpdate:groupIds": _cache[1] || (_cache[1] = ($event: any) => (form.value.group_ids = $event.map((x) => Number(x)))),
              "onUpdate:deviceIds": _cache[2] || (_cache[2] = 
            (v) => {
              form.value.device_ids = v
              nextTick(() => validateTree())
            }
          ),
              onGroupUpdate: validateTree
            }, null, 8, ["bind-mode", "group-ids", "device-ids", "preset-group-id", "permission-key", "strategy-over", "disabled"])
          ]),
          category_ids: _withCtx(() => [
            _createVNode(DomainCategoryPicker, {
              "library-urls": categoryLibraryUrls.value,
              "onUpdate:libraryUrls": _cache[3] || (_cache[3] = ($event: any) => ((categoryLibraryUrls).value = $event)),
              form: form.value,
              "extra-manual-domains": manualDomainsMergedForPicker.value,
              disabled: disabled.value,
              onToggleCustomDomains: toggleCustomDomainsSection,
              onBatchImport: _cache[4] || (_cache[4] = ($event: any) => (domainExcelImportVisible.value = true))
            }, null, 8, ["library-urls", "form", "extra-manual-domains", "disabled"])
          ]),
          "group_ids-label": _withCtx(() => [
            _createElementVNode("div", {
              class: "cm-align-center",
              style: _normalizeStyle([{"flex":"1"}, _unref(formLabelStyle)])
            }, [
              _createElementVNode("div", null, _toDisplayString(_ctx.$t('policyBindScope.applyMode')), 1)
            ], 4)
          ]),
          urls: _withCtx(({ prop, formItem }) => [
            _createElementVNode("div", {
              ref_key: "customDomainsSectionRef",
              ref: customDomainsSectionRef,
              class: _normalizeClass('el-card urls-is-error strategy-custom-domains-section'),
              style: {"height":"220px","max-height":"400px"}
            }, [
              (form.value[prop]?.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(form.value[prop], (tag, index) => {
                      return (_openBlock(), _createElementBlock("div", { key: tag }, [
                        _createVNode(_component_el_tag, {
                          closable: "",
                          size: "small",
                          onClose: ($event: any) => (handleCloseUrl(index))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(tag), 1)
                          ]),
                          _: 2
                        }, 1032, ["onClose"])
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              _createVNode(_component_el_input, _mergeProps({
                ref_key: "customDomainInputRef",
                ref: customDomainInputRef,
                class: "urls",
                style: {"border":"none"},
                modelValue: urlStr.value,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((urlStr).value = $event)),
                onKeyup: _withKeys(handleUrls, ["enter"]),
                size: "small",
                onBlur: handleUrls
              }, formItem.inputOpt, {
                placeholder: formItem.placeholder
              }), null, 16, ["modelValue", "placeholder"])
            ], 512)
          ]),
          _: 1
        }, 8, ["formSize", "modelValue", "formType", "disabled", "formColumns"]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_el_button, {
            type: "primary",
            plain: "",
            onClick: cancel,
            size: "small"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('common.cancel')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            class: "cm-ui-ml10",
            onClick: _cache[9] || (_cache[9] = ($event: any) => (handleSubmit())),
            loading: loading.value,
            size: "small"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('common.save')), 1)
            ]),
            _: 1
          }, 8, ["loading"])
        ]),
        _createVNode(_unref(ExcelImportDialog), {
          modelValue: domainExcelImportVisible.value,
          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((domainExcelImportVisible).value = $event)),
          title: _unref(t)('accessRestriction.domainStrategyImport.title'),
          copy: domainImportDialogCopy.value,
          messages: domainImportDialogMessages.value,
          "on-download-template": onDomainImportDownload,
          "on-import-file": onDomainImportFile
        }, null, 8, ["modelValue", "title", "copy", "messages"])
      ])), [
        [_directive_loading, loadingPage.value]
      ])
    : _createCommentVNode("", true)
}
}

})